import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import axios from "axios";
import { setCookie } from "nookies";
import * as jwt from "../jwt";
import { DEFAULT_TIMEOUT, getWhitelabel } from "./config";
export var HTTPService = function HTTPService(apiHostConfig, path, nextRequest, nextResponse, locale, accessToken, refreshToken, idToken) {
    "use strict";
    var _this = this;
    _class_call_check(this, HTTPService);
    var ref;
    // Request interceptor for API calls
    this.initializeRequestInterceptor = function() {
        _this.instance.interceptors.request.use(function() {
            var _ref = _async_to_generator(function(config) {
                return _ts_generator(this, function(_state) {
                    return [
                        2,
                        config
                    ];
                });
            });
            return function(config) {
                return _ref.apply(this, arguments);
            };
        }(), function(err) {
            Promise.reject(err);
        });
    };
    this.initializeResponseInterceptor = function() {
        _this.instance.interceptors.response.use(function(res) {
            // Any status code that lie within the range of 2xx cause this function to trigger
            res.config.headers["x-access-token"] = _this.accessToken || "";
            res.config.headers["x-refresh-token"] = _this.refreshToken || "";
            res.config.headers["x-id-token"] = _this.idToken || "";
            return res;
        }, _this.handleError);
    };
    var _this1 = this;
    this.handleError = function() {
        var _ref = _async_to_generator(function(err) {
            var ref, originalRequest, refreshTokenUrl, ref1, ref2, ref3, ref4, ref5, userId, res;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        originalRequest = err.config;
                        refreshTokenUrl = _this1.hostConfig.refreshTokenUrl;
                        if (!(((ref = err.response) === null || ref === void 0 ? void 0 : ref.status) === 401 && !originalRequest.retry && refreshTokenUrl)) return [
                            3,
                            2
                        ];
                        originalRequest.retry = true;
                        userId = (ref1 = jwt.decodeToken(_this1.idToken)) === null || ref1 === void 0 ? void 0 : ref1.user_id;
                        return [
                            4,
                            axios.post(refreshTokenUrl, {
                                user_id: userId,
                                refresh_token: _this1.refreshToken
                            }, {
                                headers: originalRequest.headers,
                                withCredentials: true
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        // @ts-ignore
                        originalRequest.headers.Authorization = "Bearer ".concat((ref2 = res.data) === null || ref2 === void 0 ? void 0 : ref2.access_token);
                        _this1.accessToken = (ref3 = res.data) === null || ref3 === void 0 ? void 0 : ref3.access_token;
                        _this1.idToken = (ref4 = res.data) === null || ref4 === void 0 ? void 0 : ref4.id_token;
                        setCookie({
                            res: _this1.nextResponse
                        }, "access_token", (ref5 = res.data) === null || ref5 === void 0 ? void 0 : ref5.access_token, {
                            httpOnly: true,
                            secure: "production" === "production",
                            sameSite: "strict",
                            path: "/",
                            maxAge: 60 * 60
                        });
                        return [
                            2,
                            _this1.instance(originalRequest)
                        ];
                    case 2:
                        return [
                            2,
                            Promise.reject(err)
                        ];
                }
            });
        });
        return function(err) {
            return _ref.apply(this, arguments);
        };
    }();
    this.hostConfig = apiHostConfig;
    this.path = path;
    this.ssrMode = "object" === "undefined";
    if (nextRequest) {
        this.nextRequest = nextRequest;
    }
    if (nextResponse) {
        this.nextResponse = nextResponse;
    }
    if (this.ssrMode && (nextRequest === null || nextRequest === void 0 ? void 0 : nextRequest.cookies)) {
        var ref1, ref2, ref3;
        this.accessToken = nextRequest === null || nextRequest === void 0 ? void 0 : (ref1 = nextRequest.cookies) === null || ref1 === void 0 ? void 0 : ref1.access_token;
        this.refreshToken = nextRequest === null || nextRequest === void 0 ? void 0 : (ref2 = nextRequest.cookies) === null || ref2 === void 0 ? void 0 : ref2.refresh_token;
        this.idToken = nextRequest === null || nextRequest === void 0 ? void 0 : (ref3 = nextRequest.cookies) === null || ref3 === void 0 ? void 0 : ref3.id_token;
    }
    if (accessToken) {
        this.accessToken = accessToken;
    }
    if (refreshToken) {
        this.refreshToken = refreshToken;
    }
    if (idToken) {
        this.idToken = idToken;
    }
    this.locale = locale || (nextRequest === null || nextRequest === void 0 ? void 0 : (ref = nextRequest.headers) === null || ref === void 0 ? void 0 : ref.locale) || "de-DE";
    this.instance = axios.create({
        baseURL: "".concat(apiHostConfig.baseUrl).concat(path),
        timeout: DEFAULT_TIMEOUT,
        headers: {
            "X-Whitelabel": getWhitelabel(this.locale),
            Authorization: "Bearer ".concat(this.accessToken)
        },
        withCredentials: true
    });
    this.initializeRequestInterceptor();
    this.initializeResponseInterceptor();
};
